<template>
  <div>
    <custom-label v-if="label" :item-field-name="label" />
    <v-combobox
      :value="value"
      @update:search-input="x => $emit('input', x)"
      :items="list"
      :clearable="!readonly && clearable"
      :readonly="readonly"
      rounded
      hide-details="auto"
      v-bind="$attrs"
      v-on="$listeners"
      :prepend-inner-icon="icon"
      :search-input.sync="search"
      :class="{ 'small-input': small }"
      :background-color="$vuetify.theme.themes.light.inputBackgroundColor"
    >
      <!-- <template v-for="(_, name) in $slots" v-slot:[name]="slotData">
        <slot :name="name" v-bind="slotData" />
      </template> -->
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="props">
        <slot :name="name" v-bind="props" />
      </template>
    </v-combobox>
  </div>
</template>

<script>
import { crudList } from '@/api/crud';
import api from '@/api';
import { debounce, isEqual } from 'lodash';
import customLabel from '@/components/customFormLabel/customLabel';
export default {
  name: 'masterAutocomplete',
  components: {
    customLabel,
  },
  props: {
    path: {},
    value: {},
    params: {},
    disabled: { type: Boolean, default: false },
    icon: {
      type: String,
      default: 'mdi-magnify',
    },
    small: {
      Boolean,
      default: false,
    },
    clearable: {
      Boolean,
      default: true,
    },
    readonly: {
      Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: [],
      search: null,
      debounceToGetData: debounce(this.reload, 500),
    };
  },
  methods: {
    async reload() {
      const searchResult = await crudList(api, this.path, { search: this.search, ...this.params });
      this.list = searchResult.docs || searchResult;
    },
  },
  watch: {
    search: {
      immediate: true,
      handler(v) {
        this.debounceToGetData();
      },
    },
    params: {
      handler(v, oldV) {
        if (!isEqual(v, oldV)) this.debounceToGetData();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.autoCompleted .v-icon {
  transform: rotate(0deg) !important;
}
</style>
